import { render } from "./FormatHeader3.vue?vue&type=template&id=3a93aecd"
import script from "./FormatHeader3.vue?vue&type=script&lang=js"
export * from "./FormatHeader3.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__